import storeLink from "fragments/vendors/storeLink"
import gql from "graphql-tag"

const GET_STORE_LINK_BY_ID = gql`
  ${storeLink}

  query getStoreLinkById($id: ID!) {
    getStoreLinkById(id: $id) {
      ...StoreLink
    }
  }
`
export default GET_STORE_LINK_BY_ID
